export default __webpack_public_path__ + "static/media/Black Buck.1d326709.jpg";